import { useCollection, useIO, useLinked, useModel } from "@type-r/react";
import { Loading } from "lqx-react";
import React from "react";
import { getUserDetail } from "src/app/services/can";
import { AssetType } from "../../api/assetType";
import { Company } from "../../api/company";
import { DocumentSource } from "../../api/documentSource";
import { IngestionJob } from "../../api/ingestionJob";
import { ImportTemplatesLookup } from "../../api/lookups";
import { ManualRemittanceAdvice } from "../../api/manualRemittanceAdvice";
import { AddAssetsStep } from "../add-assets-step";
import { RemittanceAdviceForm } from "./remittance-advice-form";

export const AddRemittanceAdvicesStep = ({ next, back, cancel, job }:
  { next?, back?, cancel?, job: IngestionJob }) => {
  const assetExtensions = "*.xlsx,*.xls,*.csv,*.pdf,*.msg";
  const showDownloadTemplate = true;
  const userTemplates = useModel(ImportTemplatesLookup);
  const $dataHolderId = useLinked<Company>(new Company());
  const $allowedExtension = useLinked(assetExtensions);
  const $userTemplate = useLinked<{ id?: string }>(null)
    .onChange(x => applyImportTemplateExtension(x.id));

  const isReady = useIO(async () => {
    const params = { params: { assetTypeId: AssetType.remittanceAdvice } };
    await userTemplates.fetch(params).catch(e => console.error(e));
  }, []);

  const applyImportTemplateExtension = (userTemplateId) => {
    let importTemplateExtension: string;
    if (Boolean(userTemplateId) && Boolean(userTemplates)) {
      importTemplateExtension = userTemplates.items.find((item) => item.id === userTemplateId).originalFileName.split(".").pop();
      $allowedExtension.set(`*.${importTemplateExtension}`);
    } else {
      $allowedExtension.set(assetExtensions);
    }
  }

  return isReady ?
    <>
      <AddAssetsStep
        manualAssetModel={ManualRemittanceAdvice}
        assetName="Remittance Advice"
        $dataHolderId={$dataHolderId}
        userTemplates={userTemplates}
        $userTemplate={$userTemplate}
        allowedExtension={$allowedExtension.value}
        jobInfoProvider={() => ({ ...DocumentSource.RemittanceAdvice, dataHolderId: Boolean($dataHolderId.value) ? $dataHolderId.value.id : null, userTemplateId: $userTemplate.value.id })}
        showDownloadTemplate={showDownloadTemplate}
        assetForm={manualRemittanceAdvice => <RemittanceAdviceForm remittanceAdvice={manualRemittanceAdvice}></RemittanceAdviceForm>}
        next={next} back={back} cancel={cancel} job={job} />
    </> : <Loading />
}